__turbopack_context__.v({
  "attribution": "BirdeyeWidget-module__Xs1GKG__attribution",
  "container": "BirdeyeWidget-module__Xs1GKG__container",
  "wrapper": "BirdeyeWidget-module__Xs1GKG__wrapper",
});
